<template>
  <donut-chart08-template
    :board-ids="[108, 156, 157, 158, 159]"
    :data-type="dataType"
    field-code="workplace-material"
    :graph-id="54"
    title="(원료·제조물 사업장) 유해·위험요인 조사 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart54',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
